import React from 'react'
import {Query} from 'react-apollo'
import PropTypes from 'prop-types'

import ProjectAnalytics from "./ProjectAnalytics";
import QUERY from '../../../queries/server/project_analytics'

const ProjectAnalyticsContainer = (props) => {

    const project_id = props.match.params.project_id

    return (
        <Query query={QUERY} variables={{project_id}}>
            {({data, loading, error}) => {

                console.log(data)

                if (loading) return <h1>Loading...</h1>

                return <ProjectAnalytics project={data.project}/>
            }}
        </Query>
    )

}

export default ProjectAnalyticsContainer